import { createBrowserRouter } from 'react-router-dom';
import App from './Containers/App';
import ErrorPage from './Components/ErrorPage/ErrorPage';
import HomePage from './Components/HomePage/HomePage';  
import BlogList from './Containers/Blogs/BlogList';
import BlogDetail from './Components/Blogs/BlogDetail';
import ProjectsList from './Containers/Projects/ProjectsList';
import PhotosList from './Containers/Photography/PhotosList';
import Profile from './Containers/Profile/Profile';
import About from './Components/Profile/About';
import WebDev from './Components/Profile/WebDev';
import Instrumentation from './Components/Profile/Instrumentation';
import HealthCoach from './Components/Profile/HealthCoach';
import ContactForm from './Components/ContactForm/ContactForm';

// Define the routes for the application
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />, // App component will always be rendered
    errorElement: <ErrorPage />,
    children: [
      { path: "", element: <HomePage /> }, // Home page
      { path: "blog", element: <BlogList /> }, // Blog list
      { path: "blog/:id", element: <BlogDetail /> }, // Blog detail
      { path: "projects", element: <ProjectsList /> }, // Projects list
      { path: "photography", element: <PhotosList /> }, // Photography gallery
      { path: "profile", 
        element: <Profile />, // User profile
        children: [
          { path: "", element: <About /> }, // Default to About
          { path: "about", element: <About /> },
          { path: "web-developer", element: <WebDev /> },
          { path: "instrumentation", element: <Instrumentation /> },
          { path: "health-coach", element: <HealthCoach /> }
        ]
      },
      { path: "contact", element: <ContactForm /> }, // Contact form
    ]
  }
]);

export default router;